/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Selectors for Call Details
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.4.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { ICallsDetailState } from './callsDetailReducer';
import { ICallsDetailOrderParams, ICallsDetailSummaryParams } from './callsDetailTypes';

export const makeSelectCallsDetailState = (state: IRootReducer): ICallsDetailState => state.callsDetail;

export const makeSelectCallsDetailIsStepValid = ():
    OutputSelector<IRootReducer, boolean, (state: ICallsDetailState) => boolean> =>
    createSelector(makeSelectCallsDetailState, state => state.isStepValid);

export const makeSelectCallsDetailsSummaryParams = ():
    OutputSelector<IRootReducer, ICallsDetailSummaryParams, (state: ICallsDetailState) => ICallsDetailSummaryParams> =>
    createSelector(makeSelectCallsDetailState, state => ({
        basketCount: state.basketCount,
        dateFrom: state.dateFrom,
        dateTo: state.dateTo,
    }));

export const makeSelectCallsDetailsOrderParams = ():
    OutputSelector<IRootReducer, ICallsDetailOrderParams, (state: ICallsDetailState) => ICallsDetailOrderParams> =>
    createSelector(makeSelectCallsDetailState, state => ({
        accountTakenCorporate: state.accountTakenCorporate,
        accountTakenPersonal: state.accountTakenPersonal,
        dateFrom: state.dateFrom,
        dateTo: state.dateTo,
        reportFormat: state.reportFormat,
    }));

export const makeSelectCallsDetailParams = ():
    OutputSelector<IRootReducer, ICallsDetailState, (state: ICallsDetailState) => ICallsDetailState> =>
    createSelector(makeSelectCallsDetailState, state => state);
